module.exports = __webpack_public_path__ + "static/img/zhifubaoPay.45d6244d.png";